import React from 'react';
import seloANS from '../../assets/seloANS.png';
import logoNDI from '../../assets/logo-hapvida-ndi-preto.png';

import * as S from './styles';

const Footer = () => (
    <S.FooterContainer>
        <S.AlignSection>
            <img src={seloANS} alt="selo ANS" style={{ padding: '0 24px 0 32px', width: '156px', height: '18px' }} />

            <S.TextFooter>
                Diretor Médico do NotreDame Intermédica: Dr. Rodolfo Pires de Albuquerque - CRM: 40.137 Responsável
                Técnico da Interodonto: Dr. Gustavo Bonfiglioli Ramos - CROSP: 75.093
            </S.TextFooter>
        </S.AlignSection>

        <S.SecondTextFooter>
            <img src={logoNDI} alt="Logo NDI" style={{ width: '300px', marginBottom: 20 }} />
            © 2021. NotreDame Intermédica. Todos direitos reservados.</S.SecondTextFooter>
    </S.FooterContainer>
);

export default Footer;
